import { createRequestActions } from "common/helpers/action";

export const initRegistriesList = createRequestActions("REGISTRIES.LIST.INIT");
export const scrollRegistriesList = createRequestActions("REGISTRIES.LIST.SCROLL");
export const searchRegistriesList = createRequestActions("REGISTRIES.LIST.SEARCH");
